import axios from "axios";
import { API_URL } from "../Config";
import authHeader from "./auth-header";

const list = (values) => {
  return axios.get(API_URL + "labform", {
    headers: authHeader(),
    params: values,
  });
};
const create = (values) => {
  return axios.post(API_URL + "labform/create", values, {
    headers: authHeader(),
  });
};
const update = (values) => {
  return axios.post(API_URL + "labform/update", values, {
    headers: authHeader(),
  });
};
const destroy = (values) => {
  return axios.post(API_URL + "labform/destroy", values, {
    headers: authHeader(),
  });
};

const labFormService = { list, create, update, destroy };

export default labFormService;
